import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TransactionViewModel } from './transaction-history.page';

@Component({
    selector: 'app-transaction-history-item-header[transaction]',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [`
    :host {
      display: block;
    }
  `],
    template: `
    <div class="d-flex flex-row border-bottom p-3">
      <div class="flex-column flex-grow-1">
        <div class="d-flex flex-row ps-3">
          <div class="d-block circular-image rounded-circle bg-light shadow-sm border"
               [style.background-image]="transaction?.userAvatar && 'url(' + transaction?.userAvatar + ')'">
          </div>
          <div class="flex-grow-1 ps-2">
            <div>
              <span class="text-muted fs-5" i18n>Verkauf:</span><span class="fw-bolder ps-2 fs-5">
              #{{transaction?.transactionNumber}}
            </span>
            </div>
            <div>
              <span class="fw-bold">{{transaction?.userName}}</span>
              <span class="ps-4 text-muted">{{transaction | formatDate}} {{transaction | formatTime}} Uhr
                ({{transaction?.createdAt | dateFromNow}})</span>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-column d-flex align-items-end">
        <span class="flex-row fs-5 text-info fw-bold">{{transaction?.total | currency}}</span>
        <span class="flex-row text-muted">{{transaction?.taxTotal | currency }} MWSt</span>
      </div>
    </div>
  `,
    standalone: false
})
export class HistoryItemHeaderComponent {
  @Input() transaction!: TransactionViewModel | null;
}
